const fontConfig = {
  light: {
    fontFamily: "Mukta Vaani",
    fontWeight: 100,
  },
  regular: {
    fontFamily: "Mukta Vaani",
    fontWeight: 300,
  },
  medium: {
    fontFamily: "Mukta Vaani",
    fontWeight: 500,
  },
  semibold: {
    fontFamily: "Mukta Vaani",
    fontWeight: 700,
  },
  bold: {
    fontFamily: "Mukta Vaani",
    fontWeight: 900,
  },
};
export default fontConfig;
